/* eslint-disable no-unused-vars */
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { CustomHelperText, Wrapper } from './ActivePhoneTable.Styles';
var columns = [
    {
        field: 'active',
        headerName: 'Active',
        flex: 1,
        editable: true
    },
    {
        field: 'inactive',
        headerName: 'Inactive',
        flex: 1,
        editable: true
    },
];
var rows = [
    { id: '1', active: '', inactive: 'Home' },
    { id: '2', active: '', inactive: 'Cell' },
    { id: '3', active: '', inactive: 'Work' },
    { id: '4', active: '', inactive: 'Other' },
];
/**
 * @deprecated Use DuoColumnSelector instead
 */
export var ActivePhoneTable = function (props) {
    var getRow = function () {
        var values = props.field.value;
        var _rows = rows.map(function (row) {
            var val = row.active || row.inactive;
            if (values.find(function (_val) { return _val === val; })) {
                return { id: row.id, active: val, inactive: '' };
            }
            else {
                return { id: row.id, active: '', inactive: val };
            }
        });
        return _rows;
    };
    var onRowClickHandle = function (row) {
        var activeValue = props.field.value;
        var val = row.active || row.inactive;
        if (activeValue.find(function (_val) { return _val === val; })) {
            var index = activeValue.indexOf(val);
            activeValue.splice(index, 1);
        }
        else {
            activeValue.push(val);
        }
        props.form.setFieldValue(props.field.name, activeValue);
        props.form.setFieldTouched(props.field.name, true);
    };
    var willError = props.form.touched[props.field.name] &&
        !!props.form.errors[props.field.name];
    return (React.createElement(Wrapper, null,
        React.createElement(CustomHelperText, null, props.label),
        React.createElement(DataGrid, { rows: getRow(), columns: columns, pageSize: 4, rowsPerPageOptions: [4], onRowClick: function (e) { return onRowClickHandle(e.row); }, hideFooter: true, autoHeight: true, density: 'compact' }),
        willError && (React.createElement(CustomHelperText, { error: willError }, props.form.errors[props.field.name]))));
};
ActivePhoneTable.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=ActivePhoneTable.js.map